import { vdmContracts } from "./vdm.contract";
import { edi844SubmissionsContracts } from "./edi844-submissions.contract";
import {
  edi849ResponsesContract,
  edi849UserResponsesContract,
} from "./edi849-responses.contract";
import { e844sdTransactionsContracts } from "./e844sd-transactions.contract";
import { e844sdFieldSchemaContracts } from "./e844sd-field-schema.contract";
import { e849FieldSchemaContracts } from "./e849-field-schema.contract";
import { rexelFileSearchContracts } from "./rexel-file-search.contract";
import { orderdadSearchContracts } from "./orderdad-search.contract";
import { companyLocationsContracts } from "./company-locations.contract";
import { sdAdminReportsContracts } from "./sd-admin-reports.contract";

export const shipAndDebitContracts = {
  vdms: vdmContracts,
  edi844Submissions: edi844SubmissionsContracts,
  edi849Responses: edi849ResponsesContract,
  edi849UserResponses: edi849UserResponsesContract,
  e844sdTransactions: e844sdTransactionsContracts,
  e844sdFieldSchema: e844sdFieldSchemaContracts,
  e849FieldSchema: e849FieldSchemaContracts,
  rexelFileSearch: rexelFileSearchContracts,
  orderdadSearch: orderdadSearchContracts,
  companyLocations: companyLocationsContracts,
  adminReports: sdAdminReportsContracts,
} as const;

export * from "./vdm.contract";
export * from "./edi844-submissions.contract";
export * from "./edi849-responses.contract";
export * from "./e844sd-transactions.contract";
export * from "./e844sd-field-schema.contract";
export * from "./e849-field-schema.contract";
export * from "./rexel-file-search.contract";
export * from "./orderdad-search.contract";
export * from "./company-locations.contract";
export * from "./sd-admin-reports.contract";
